import { contrastColor } from "contrast-color";

/**
 * Initialize a `$contrastColor` magic value for Alpine.
 *
 * Returns either a dark or light color (black/white by default) depending
 * on the luminance of the given background color, so that text placed on
 * that background remains readable.
 *
 * @param {import("alpinejs").Alpine} Alpine - The Alpine instance
 *
 * Usage:
 *
 *   <div :style="{ color: $contrastColor(bgColor) }">...</div>
 *
 *   With custom dark/light colors:
 *
 *   <div :style="{ color: $contrastColor(bgColor, { fgDarkColor: '#1a1a1a', fgLightColor: '#fafafa' }) }">...</div>
 */
export default (Alpine) => {
  Alpine.magic(
    "contrastColor",
    () =>
      (bgColor, options = {}) =>
        contrastColor({ bgColor, ...options })
  );
};
